import { useRoute } from 'vue-router'

import type { NavItem } from '@/constants/app/navigation.constant.js'
import { isItemActive } from '@/utils/visible-navigation.util.js'

/**
 * "Is this nav item the current screen?" — one rule for the section nav, the mobile section
 * tabs and the menu sheet, so the three cannot disagree about which item is lit.
 *
 * Detail routes name their list as `meta.parent`, so "Shops" stays lit on `/shops/:id`;
 * the rule itself (route name AND every query key the item carries) is in
 * `visible-navigation.util.ts`, where it is tested.
 */
export function useActiveNavItem(): (item: NavItem) => boolean {
  const route = useRoute()

  return (item) => {
    const name = typeof route.meta.parent === 'string' ? route.meta.parent : route.name

    return isItemActive(item, typeof name === 'string' ? name : null, route.query)
  }
}
